import { cn } from "#app/utils/misc"

export default function GretasPatchwork({ className }: { className?: string }) {
	return (
		<img
			src="/logos/gretas-patchwork.svg"
			alt="Greta's Patchwork"
			className={cn("h-auto w-full max-w-[358px]", className)}
			width={358}
			height={133}
		/>
	)
}
